import { AttendeesFilterModel } from '@routes/events/models/attendeelist-model';
import { ActivityTimeRange, IActivityLogBase } from '@shared/services/activity-service/activity.models';

export class ActivityFilter {
    constructor(public timeRange: ActivityTimeRange, public category: ActivityCategory = null, public userId: string = null, public searchTerm= null) { }
  }

export enum ActivityCategory {
    CheckIn = 0,
    CheckOut = 1,
    NoShow = 2,
    Invitations = 3,
    Export = 5
}

export enum AttendeeType {
    Invitee = 0,
    ExtraGuest = 1,
}

export interface IActivityLog  extends IActivityLogBase {
    showExtraGuests: boolean;
    eventName: string;
    inviteeName: string;
    inviteeEmail: string;
    attendeeName: string;
    attendeeEmail: string;
    attendeeType: AttendeeType;
    attendees: Attendee[];
    attendeesLabel: string;
    attendeeNames: string[];
    eventUsesFieldDrive: boolean;
}
export interface IActivities {
    activities: IActivityLog[];
}

export interface Attendee {
    email: string;
    name: string;
    type: AttendeeType;
}

export interface IActivityLogs {
    activities: IActivityLog[];
}


export interface IAttendeeUpdateGroups {
    isSelectAll: boolean;
    filterModel: AttendeesFilterModel;
    attendeeIds: string[];
    groupIdsAdd: string[];
    groupIdsRemove: string[];
}

export class AttendeeUpdateGroups implements IAttendeeUpdateGroups {
    constructor(
        public isSelectAll: boolean,
        public filterModel: AttendeesFilterModel,
        public attendeeIds: string[],
        public groupIdsAdd: string[],
        public groupIdsRemove: string[]
    ) { }
}

export interface IAttendeeUpdateDocuments {
    attendeeIds: string[];
    documentIds: string[];
}

export class AttendeeUpdateDocuments implements IAttendeeUpdateDocuments {
    constructor(
        public attendeeIds: string[],
        public documentIds: string[]
    ) { }
}

export interface IAttendeeDocumentDetails {
    id: string;
    names: DocumentName[];
    type: number;
    fileName: string;
}

export class AttendeeDocumentDetails implements IAttendeeDocumentDetails {
    constructor(
        public id: string,
        public names: DocumentName[],
        public type: number,
        public fileName: string
    ) { }
}

export interface DocumentName {
    id: string;
    languageId: string;
    value: string;
}

export interface IDocumentBadge {
    attendeeDocuments: IAttendeeDocumentDetails[];
}

export interface IAttendeeDocumentPDFRequest {
    documentName: string;
    languageId: string;
}

export interface IPorscheExports{
    porscheExports: IPorscheExport[];
}

export interface IPorscheExport {
    actvt: string;
    address: string;
    addressType: string;
    agreedDataProtection: string;
    campaignId: string;
    isUsedCarInterest: string;
    isNewCarInterest: string;
    city: string;
    company: string;
    conStatus: string;
    countryCode: string;
    dealerContact: string;
    email: string;
    eventActualDate: string;
    eventDescription: string;
    eventName: string;
    eventParticipation: string;
    eventPlanDate: string;
    eventStartDate: string;
    extraCampaignId: string;
    firstName: string;
    title: string;
    titleName: string;
    modelCode: string;
    isEmailBlock: string;
    isFaxBlock: string;
    isMailBlock: string;
    isPhoneBlock: string;
    lastName: string;
    mobileNumber: string;
    modelVariantCode: string;
    partner: string;
    porscheCenter: string;
    postCode: string;
    purchaseInterestMonth: string;
    purchaseInterestYear: string;
    source: string;
    street: string;
    streetNumber: string;
  }
